import React, { Component } from 'react';
import  SearchForm  from "../util/searchform/SearchForm";
import  TableTemplate  from "../util/tabletemplate/TableTemplate";
import  NoItems  from "../util/noitems/NoItems";
import EstacionesCocinaAPI from '../../services/EstacionesCocina';
import { toast } from 'react-toastify';
import Modal from '../util/modal/Modal';
import EstacionCocinaForm from './EstacionCocinaForm';
import AcceptModal from '../util/acceptModal/AcceptModal';
import Pagination from '../util/pagination/Pagination';
import Loading from '../util/loading/Loading';

import ModoGuiado from "../modoGuiado/ModoGuiado"
import BtnModoGuiado from '../util/BtnModoGuiado/BtnModoGuiado'
import ErrorMessages from '../../util/validation-error-messages';
import lodash from 'lodash';
import roles from '../../util/strings/roles';


class EstacionesCocina extends Component {
    estacionesCocina = [];

    constructor(props){
        super(props);
        this.state = {
            estacionesCocina: [],
            pageEstacionCocina: [],
            filterText: "",
            estacionCocina: null,
            showModal: false,
            removeModal: false,
            isLoading: false
        }
    }

    componentWillMount(){
        this.setState({isLoading: true}, () => {
            EstacionesCocinaAPI.getAll().then(response => {
                this.setState({estacionesCocina: response.data, isLoading: false});
                this.estacionesCocina = response.data;
            }).catch(err => {
                this.setState({isLoading: false})
                if(err.response)
                    toast.error(err.response.data);
                else
                    toast.error(ErrorMessages.SinConexion);
            })
        });
    }

    // Método encargado de recibir el texto en el input de búsqueda y filtrar los elementos en
    // la tabla 
    handleSearchInput = (text) => {
        let estacionesCocina = this.estacionesCocina.filter(estacionCocina => estacionCocina.Descripcion.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(text.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")));
        let state = this.state;
        state.filterText = text;
        state.estacionesCocina = estacionesCocina;
        this.setState(state);
    }

    save = (estacionCocina) => {
        this.setState({isLoading: true});
        console.log(estacionCocina);
        if(estacionCocina.IdEstacion === 0 || estacionCocina.IdEstacion === null || estacionCocina.IdEstacion === undefined){
            EstacionesCocinaAPI.create(estacionCocina).then(response => {
                let state = {...this.state};
                estacionCocina.IdEstacion = response.data;
                state.estacionesCocina.push(estacionCocina);
                state.pageEstacionCocina.push(estacionCocina);
                state.showModal = false;
                state.isLoading = false;
                this.setState(state, () => {
                    toast.success("Estación de cocina registrada.");
                });
            }).catch(err => {
                this.setState({isLoading: false});
                console.log(err)
                if (err.response) {
                    toast.error(err.response.data)
                } else {
                    toast.error(ErrorMessages.SinConexion);
                }
            })
        }else{
            EstacionesCocinaAPI.edit(estacionCocina).then(response => {
                let state = {...this.state};
                state.estacionesCocina[state.estacionesCocina.findIndex(u => u.IdEstacion === estacionCocina.IdEstacion)] = estacionCocina;
                state.pageEstacionCocina[state.pageEstacionCocina.findIndex(u => u.IdEstacion === estacionCocina.IdEstacion)] = estacionCocina;
                state.showModal = false;
                state.isLoading = false;
                this.setState(state, () => {
                    toast.success("Estación de cocina actualizada");
                });
            }).catch(err => {
                this.setState({isLoading: false});
                if (err.response) {
                    toast.error(err.response.data)
                } else {
                    toast.error(ErrorMessages.SinConexion);
                }
            })
        }
    }

    remove = (estacionCocina) => {
        let state = {...this.state};
        const loadingToast = toast.info("Cargando...", {autoClose: false, closeButton: false, className: "has-background-primary has-text-weight-bold"});
        
        EstacionesCocinaAPI.delete(estacionCocina).then(response => {
            state.estacionesCocina.splice(state.estacionesCocina.findIndex(u => u.IdEstacion === estacionCocina.IdEstacion),1);
            state.pageEstacionCocina.splice(state.pageEstacionCocina.findIndex(u => u.IdEstacion === estacionCocina.IdEstacion),1);
            this.estacionesCocina.splice(this.estacionesCocina.findIndex(u => u.IdEstacion === estacionCocina.IdEstacion),1);
            state.removeModal = false;
            this.setState(state, () => {
                toast.dismiss(loadingToast);
                toast.success("Estación de cocina eliminada");
            })
        }).catch(err => {
            toast.dismiss(loadingToast);
            state.removeModal = false;
            if (err.response) {
                toast.error(err.response.data)
            } else {
                toast.error(ErrorMessages.SinConexion);
            }
            this.setState(state);
        })
    }

    sincronizarEstacionesRecetas = () =>{
        this.setState({isLoading: true});
        let state = {...this.state};
        EstacionesCocinaAPI.sincronizarEstacionesRecetas().then(response => {
            this.setState(state, () => {
                toast.success("Estaciones y recetas sincronizados");
            });
        }).catch(err => {
            state.isLoading = false;
            this.setState(state, () => {
                toast.error("Error al sincronizar estaciones y recetas");
            });
        })
    }

    render() {
        return (
            <div>

                <ModoGuiado 
                    ruta="estaciones-cocina"
                    tipoModoGuiado="articulo"
                    siguiente='tipo-inventario'
                    mensaje="Estación de cocina para la gestión de recetas" />

                <h1 className="title is-2">Estaciones de Cocina</h1>
                <div className="columns is-vcentered">
                    <div className="column is-6">
                        <div className="card">
                            <div className="card-content">
                                <div className="field">
                                    <div className="control">
                                        <SearchForm
                                            filterText={this.state.filterText}
                                            onInput={(t) => this.handleSearchInput(t)}
                                            itemName={'Estación de Cocina'}
                                            placeholderText = {"Ingrese nombre de la estación de cocina"}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="column is-3">
                        <div className="field">
                            <div className="control has-text-right">
                                {lodash.intersection(localStorage.getItem('role').split(","), [roles.ADMIN, roles.ESPECIALISTA_DE_PRODUCTO, roles.COORDINADOR_GESTION_OPERACIONES]).length > 0 &&
                                    <a id="btnAddEstacion" className="button is-success" tabIndex="0" onClick={(estacionCocina) => this.setState({showModal: true, estacionCocina: null})}>
                                        <span className="icon is-small">
                                            <i className="fa fa-plus"></i>
                                        </span>
                                        <span>Agregar Estación de Cocina</span>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="column is-3">
                        <div className="field">
                            <div className="control has-text-right">
                                {lodash.intersection(localStorage.getItem('role').split(","), [roles.ADMIN, roles.ESPECIALISTA_DE_PRODUCTO, roles.COORDINADOR_GESTION_OPERACIONES]).length > 0 &&
                                    <a id="btnAddRecetas" className="button is-info" 
                                        onClick={() => this.props.history.push({
                                            pathname: `/estaciones-cocina/0/detalle`,
                                            state: {name: "Mover Receta a Estación"}
                                        })}>
                                        <span className="icon is-small">
                                            <i className="fa fa-exchange"></i>
                                        </span>
                                        <span>Mover Receta a Estación</span>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>                       

                </div>

                <div className="card">
                    <div className="column is-3">
                        <div className="field">
                            <div className="control has-text-right">
                                {lodash.intersection(localStorage.getItem('role').split(","), [roles.ADMIN, roles.ESPECIALISTA_DE_PRODUCTO, roles.COORDINADOR_GESTION_OPERACIONES]).length > 0 &&
                                    <a id="btnSyncEstacionesRecetas" className="button is-success" tabIndex="0" onClick={() => this.sincronizarEstacionesRecetas()}>
                                        <span className="icon is-small">
                                            <i className="fa fa-refresh"></i>
                                        </span>
                                        <span>Sincronizar Estaciones y Recetas</span>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="card-content" >
                        {this.state.estacionesCocina.length !== 0 
                        ? <TableTemplate
                            columns={["IdEstacion","Descripcion"]}
                            columnsNames={["ID", "Descripcion"]}
                            data={this.state.pageEstacionCocina}
                            rowClickable={true}
                            details={(estacionCocina) => this.props.history.push({
                                pathname: `/estaciones-cocina/${estacionCocina.IdEstacion}/detalle`,
                                state: {name: "Estación de Cocina: " + estacionCocina.Descripcion}
                            })}
                            canEdit canDelete 
                            edit={(estacionCocina) => this.setState({showModal: true, estacionCocina: estacionCocina})} 
                            remove={(estacionCocina) => this.setState({removeModal: true, estacionCocina: estacionCocina})}
                            
                        /> 
                        : <NoItems itemName="estaciones de cocina"/>}
                        
                        <Pagination items={this.state.estacionesCocina} onChangePage={(estacionesCocina) => this.setState({ pageEstacionCocina: estacionesCocina })} />
                        
                        
                    </div>
                </div>
                {this.state.showModal && 
                    <Modal
                        showModal={this.state.showModal}
                        modalTitle={"Editar Estación de Cocina"}
                        cancel={() => this.setState({showModal: false, estacionCocina: null})}
                    >
                        <EstacionCocinaForm
                            estacionCocina={this.state.estacionCocina}
                            save={this.save}
                            estacionesCocina={this.state.estacionesCocina}
                        />   
                    </Modal>
                }
                {this.state.removeModal && <AcceptModal
                    isActive={this.state.removeModal}
                    done={() => this.remove(this.state.estacionCocina)}
                    cancel={() => this.setState({removeModal: false, estacionCocina: null})}
                    modalTitle={"Eliminar Estación de Cocina"}
                    modalBody={"¿Está seguro(a) de eliminar Estación de Cocina?"}
                />}
                <Loading isFullscreen={true} isLoading={this.state.isLoading} width='100px' height='100px'/>

                <BtnModoGuiado />                

            </div>
        );
    }
}

export default EstacionesCocina;
